import React from "react";

function TrafficHomeOne({ className }) {
  return (
    <section className={`appie-service-area pt-140 pb-180 ${className || ""}`}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="appie-traffic-title">
              <h3 className="title">Squash Rules and Regulations</h3>

              <p>a. Common Rules</p>
              <p>• 2 Points per win</p>
              <p>
                • The competition would be player-wise &amp; not club-wise where
                maximum 3 players &amp; minimum 1 player can play
              </p>
              <p>
                • Mixed teams, comprising both male and female players, are
                allowed.
              </p>
              <h3>Playing Conditions</h3>
              <p>
                • Dunlop double dot ball will be used during the competition.
              </p>
              <p>• League Matches will be played on best of three 11 points</p>
              <p>• Knockout matches would be of best of five 11 points</p>
              <p>
                • WSF (World Squash Racket Federation) rules will be followed
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TrafficHomeOne;
